import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CuentaOrdenante } from '../../../models/cuenta-ordenante';
import { generalService} from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'my-ordenante-detalle',
  styles: [],
  templateUrl: './cuenta-ordenante-detalle.component.html',
  providers: [generalService]
})

export class OrdenanteDetalleComponent implements OnInit {
  public ordenante: CuentaOrdenante = new CuentaOrdenante();
  ordenanteAgregar: FormGroup;
  titulo = "Agregar";
  listaBancos: any[] = [];

  constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService) { 
    this.dataService.guardadoModal=false;
  }

  ngOnInit() {
    this.buildForm();
    this.consultarBancos();
    if(this.dataService.tipoModal == "editar"){
      this.titulo = "Editar";
      this.ordenante.ORIGINATOR_BACK_ACCOUNT_ID = this.dataService.id;
      this.buscarOrdenante();
    }
  }

  buscarOrdenante(){
      this._generalService.metodoCallParams(this.ordenante, "ReciboPagoComponentes/consultarOrdenante/").subscribe(
        result => {
          this.ordenante = JSON.parse(result.replace("[", "").replace("]", ""));          
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  consultarBancos() {
    this._generalService.metodoCall(`ReciboPagoComponentes/ConsultBank/`).subscribe(
        (result) => {
            const res = JSON.parse(result);
            if (res !== null && res !== undefined && res.length > 0) {
                this.listaBancos = res;
            } else {
                this.listaBancos = [];
            }
        },
        (error) => {
            this.listaBancos = [];
            console.log( error as any);
        }
    );
  }

  buildForm() {
    this.ordenanteAgregar = this.formBuilder.group({
      NAME: this.formBuilder.control(null, [Validators.required, Validators.maxLength(250)]),
      ACCOUNT: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
      RFC: this.formBuilder.control(null),
      IS_FOREIGN: this.formBuilder.control(null),
      BANK_NAME: this.formBuilder.control(null),
      BANCO: this.formBuilder.control(null, [Validators.required]),
    });

    this.ordenanteAgregar.controls['RFC'].disable();
  }

  cerrarModal(){
    this.dataService.dialogModal.close();
  }

  onSubmit() {
    if (this.ordenante.IS_FOREIGN) {
      if (this.ordenante.BANK_NAME == "" || this.ordenante.BANK_NAME == undefined || this.ordenante.BANK_NAME == null) {
        this._generalService.toastCall('El nombre del banco es requerido cuando la cuenta es foránea');
        return false;
      }

      this.ordenante.BANK_ID = null;
    } else {
      this.ordenante.BANK_ID = this.ordenanteAgregar.controls["BANCO"].value;
    }

    let metodo = "ReciboPagoComponentes/InsertarOrdenante/";
    if (this.dataService.tipoModal == "editar") {
      metodo = "ReciboPagoComponentes/ActualizarOrdenante/";
    } else {
      this.ordenante.CUSTOMER_ID = this.dataService.idCliente;
    }
    
    this._generalService.metodoCallParams(this.ordenante, metodo).subscribe(
        result => {
          this.dataService.guardadoModal=true;
          this.cerrarModal();
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
    ); 
  }

  RFCDefault(event: any) {
    if (event.checked) {
        this.ordenante.RFC = "XEXX010101000";
        this.ordenanteAgregar.controls['BANCO'].disable();
        this.ordenanteAgregar.controls['BANCO'].setValue(undefined);
    } else {
        this.ordenante.RFC = "";
        this.ordenanteAgregar.controls['BANCO'].enable();
    }
  }

  setRFC(event) {
    if(event) {
        const banco = this.listaBancos.find((element) => element.BANK_ID === event);
        this.ordenanteAgregar.controls["RFC"].setValue(banco.RFC);
    } else {
        this.ordenanteAgregar.controls["RFC"].setValue(undefined);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/recibo-pago/cuenta-ordenante/agregar-editar/cuenta-ordenante-detalle.component.ts